import { render, staticRenderFns } from "./OrderAccess.vue?vue&type=template&id=ced56eb4"
import script from "./OrderAccess.vue?vue&type=script&lang=js"
export * from "./OrderAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports